/* Mock-adapter root.
 *
 * Customer-facing surface only: auth, catalogue, cart, checkout, orders,
 * profile, enquiries, notifications.
 */

import * as auth from "./auth";
import { products, categories } from "./catalogue";
import * as cart from "./cart";
import * as checkout from "./checkout";
import * as orders from "./orders";
import * as profile from "./profile";
import * as enquiries from "./enquiries";
import * as notifications from "./notifications";

export const mockApi = {
  get base() { return ""; },
  health: async () => ({ status: "ok", mode: "mock" }),

  products,
  categories,

  auth: {
    signup: auth.signup,
    login: auth.login,
    refresh: auth.refresh,
    logout: auth.logout,
    me: auth.me,
    forgot: auth.forgot,
    reset: auth.reset,
  },

  cart: {
    get: cart.get,
    add: cart.add,
    update: cart.update,
    remove: cart.remove,
    applyCoupon: cart.applyCoupon,
    removeCoupon: cart.removeCoupon,
    clear: cart.clear,
    claim: cart.claim,
    release: cart.release,
  },

  checkout: {
    quote: checkout.quote,
    place: checkout.place,
  },

  orders: {
    list: orders.list,
    get: orders.get,
    cancel: orders.cancel,
    reorder: orders.reorder,
    track: orders.track,
  },

  profile: {
    get: profile.get,
    update: profile.update,
    addresses: {
      list: profile.addresses_list,
      get: profile.addresses_get,
      create: profile.addresses_create,
      update: profile.addresses_update,
      delete: profile.addresses_delete,
      setDefault: profile.addresses_setDefault,
    },
  },

  enquiries: {
    list: enquiries.list,
    get: enquiries.get,
    create: enquiries.create,
    reply: enquiries.reply,
    close: enquiries.close,
    acceptQuote: enquiries.acceptQuote,
  },

  notifications: {
    list: notifications.list,
    unreadCount: notifications.unreadCount,
    markRead: notifications.markRead,
    markAllRead: notifications.markAllRead,
    delete: notifications.deleteOne,
  },
};

export default mockApi;
